import React, { useEffect, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import { configurationAttributeType, activityTabOptions,newConfigurationNames, defaultLayoutConfiguationValues } from '../../types'
import "./OutletActivityTabsConfiguration.css"
import { doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import * as Sentry from "@sentry/react";
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { openPopup } from '../../stateManagement/actions/popupActions'
import GenricMultiSelect from '../../components/Input/GenericMultiSelect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { DragDropContext, Draggable, DraggableProvided, Droppable, DropResult } from 'react-beautiful-dnd'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { Loader } from '../../components/loader/Loader'

import { Accordion, AccordionDetails, AccordionSummary,  TextField, Typography } from '@mui/material'
import { DashboardCheckbox } from '../../components/Input/Input'

const defaultOptions: defaultLayoutConfiguationValues = {
    outletActivityTabs: {
        "name": "outletActivityTabs",
        "type": "list",
        "value": [ ],
        "docUrl": "",
        "description": "outlet activity configuration",
        "possibleVals": [
            {
                "id": "taskRecommendations",
                "label": "TASK RECOMMENDATIONS",
                "iconPath": "assets/svg/competition_tracking.svg",
                "isDefault": false,
                "themeColor": "#A52A2A",
                "storeInRequired": ""
            },
            {
                "id": "competitionTracking",
                "label": "COMPETITION TRACKING",
                "iconPath": "assets/svg/competition_tracking.svg",
                "isDefault": false,
                "themeColor": "#e1ad01",
                "storeInRequired": ""
            },
            {
                "id": "npdDisplay",
                "label": "NPD DISPLAY",
                "iconPath": "assets/svg/competition_tracking.svg",
                "isDefault": false,
                "themeColor": "#e1ad01",
                "storeInRequired": ""
            }
        ]
    }
}

const activityTabOptionsMapping: { [key: string]: activityTabOptions } = {
    "taskRecommendations": {
        "id": "taskRecommendations",
        "label": "TASK RECOMMENDATIONS",
        "iconPath": "assets/svg/competition_tracking.svg",
        "isDefault": false,
        "themeColor": "#A52A2A",
        "storeInRequired": ""
    },
    "competitionTracking": {
        "id": "competitionTracking",
        "label": "COMPETITION TRACKING",
        "iconPath": "assets/svg/competition_tracking.svg",
        "isDefault": false,
        "themeColor": "#e1ad01",
        "storeInRequired": ""
    },
    "npdDisplay": {
        "id": "npdDisplay",
        "label": "NPD DISPLAY",
        "iconPath": "assets/svg/competition_tracking.svg",
        "isDefault": false,
        "themeColor": "#e1ad01",
        "storeInRequired": ""
    },
}


const OutletActivityTabsConfiguration = () => {
    const [salesRepConfig, setSalesRepConfig] = useState<configurationAttributeType<activityTabOptions[]>[]>([]);
    const [values, setValues] = useState<defaultLayoutConfiguationValues>(deepClone(defaultOptions));
    const [availableActivityTabOptions, setAvailableActivityTabOptions] = useState<string[]>([]);
    const [selectedActivityTabOptions, setSelectedActivityTabOptions] = useState<string[]>([]);
    const [showLoader, setShowLoader] = useState<boolean>(false);
  const [isValidColor, setIsValidColor] = useState<boolean>(true);


    const maxValue = 5, minValue = 4;

    useEffect(() => {
        const getOutletActivityTabConfiguration = async () => {
            try {
                setShowLoader(true);
                const resp = await getNewConfiguration('salesrep_app_layout_configuration');

                const salesrep_app_layout_config: configurationAttributeType<activityTabOptions[]>[] = resp?.domainValues ?? [];

                const outletActivityTabs = salesrep_app_layout_config.find(config => config.name === "outletActivityTabs");

                let finalValues = outletActivityTabs ? [...outletActivityTabs.value] : values.outletActivityTabs.value;

                finalValues = finalValues.map((option: activityTabOptions) => {
                    const possibleValObj = values.outletActivityTabs.possibleVals.find((possibeValOption: any) => {
                        return possibeValOption.id === option.id;
                    });
                    return {
                        ...option,
                        // compulsory: possibleValObj?.compulsory || false
                    }
                })
                //adding compulsory options
                // for(let possibleVal of values.outletActivityTabs.possibleVals){
                //     const isPresent = finalValues.find((valueOption: activityTabOptions) => valueOption.id === possibleVal.id);
                //     if(possibleVal.compulsory && !isPresent){
                //         finalValues.push(possibleVal);
                //     }
                // }
                values.outletActivityTabs.value = finalValues;

                const activityTabOptions = values.outletActivityTabs.possibleVals.filter((possibleValOption: activityTabOptions) => {
                    return !values.outletActivityTabs.value.find((valueOption: activityTabOptions) => possibleValOption.id === valueOption.id);
                }).map((option: activityTabOptions) => option.id);

                setSalesRepConfig(salesrep_app_layout_config);
                setValues({ ...values });
                setAvailableActivityTabOptions(activityTabOptions);
                setShowLoader(false);
            } catch (err) {
                // Sentry.captureException(err);
            }
        }
        getOutletActivityTabConfiguration();
    }, []);

    function handleSelectedOutletActivityTabOptions(selectedOptions: string[]) {
        setSelectedActivityTabOptions(selectedOptions);
    }
    function handleAddOutletActivityTabOptions() {
        const newOutletActivityTabValues = selectedActivityTabOptions.map((selectedOption: string) => {
            const selectedObject = activityTabOptionsMapping[selectedOption];
            return {

                id: selectedOption,
                label: selectedObject?.label,
                iconPath: selectedObject?.iconPath,
                isDefault: selectedObject?.isDefault,
                themeColor: selectedObject?.themeColor,
                storeInRequired: selectedObject?.storeInRequired

                // label: selectedOption,
                // id: OutletActivityTabOptionsMapping[selectedOption],
                // compulsory: false  //as compulsory are added automatically on initial load(i.e only compulsory: false ones can be added through drop down)
            };
        })
        values.outletActivityTabs.value = [...values.outletActivityTabs.value, ...newOutletActivityTabValues];
        const newAvailableOutletActivityTabOptions = availableActivityTabOptions.filter((availableOption: string) => {
            return !selectedActivityTabOptions.find((selectedOption: string) => {
                return selectedOption === availableOption;
            })
        })
        setValues({ ...values });
        setSelectedActivityTabOptions([]);
        setAvailableActivityTabOptions(newAvailableOutletActivityTabOptions);
    }
    function handleRemove(targetLabel: string) {
        const filteredValues = values.outletActivityTabs.value.filter((activityOption: activityTabOptions) => {
            return activityOption.id !== targetLabel;
        })
        values.outletActivityTabs.value = filteredValues;
        setValues({ ...values });
        setAvailableActivityTabOptions([targetLabel, ...availableActivityTabOptions]);
    }
    function validateOutletActivityTabConfig() {
        if (values.outletActivityTabs.value.length > maxValue) {
            return `OutletActivityTab Items can be ${maxValue} at max`;
        } else if (values.outletActivityTabs.value.length < minValue) {
            return `OutletActivityTab Items must be atleast ${minValue} `;
        }
        return "";
    }
    const saveConfiguration = async (preview?: boolean) => {
        // const message = validateOutletActivityTabConfig();
        // if (message !== "") {
        //     openPopup("Alert", message);
        //     return;
        // }

            try {
                let result = { ...values };
                // result.outletActivityTabs.value = result.outletActivityTabs.value.map((tabOption: activityTabOptions) => {
                //     const { id, label } = tabOption;
                //     return {
                //         id,
                //         label
                //     }
                // });
                const configName: newConfigurationNames = 'salesrep_app_layout_configuration';
                let clientConfig = await getMetaDataConfig("clientconfig");
                const convertedVals = [...salesRepConfig];
                Object.keys(result).forEach(key => {
                    const activityTabObject = convertedVals.find(config => config.name === key)
                    if (activityTabObject) {
                        activityTabObject.value = result[key].value;
                    } else {
                        const configObj = { ...result[key] };
                        Reflect.deleteProperty(configObj, 'possibleVals');
                        convertedVals.push(configObj);
                    }
                })
                await doFinalConfigSubmit(configName,convertedVals);
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                openPopup('Error', "Validation Error occured")
            }
    }
    function handleDragOnEnd(result: DropResult) {
        if (result.destination !== null) {
            const items = Array.from(values.outletActivityTabs.value);
            const [reorderedItem] = items.splice(result.source.index, 1);
            if (result.destination)
                items.splice(result.destination.index, 0, reorderedItem);

            values.outletActivityTabs.value = items;
            setValues({ ...values });
        }
    }

    function handleTextInputChange(e: any, index: number, key: string) {
        const newValues = { ...values };
        newValues.outletActivityTabs.value[index] = { ...newValues.outletActivityTabs.value[index], [key]: e.target.value }
        setValues({ ...values });
    }

    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>, index: number,) => {
        const newValues = { ...values };
        newValues.outletActivityTabs.value[index] = { ...newValues.outletActivityTabs.value[index], isDefault: e.target.checked }
        setValues({ ...values });
    }

    const isValidHexColor = (colorString: string) => {
        if (colorString.length < 7) {
          return false;
        }
        return /^#([0-9A-F]{3}){1,2}$/i.test(colorString);
      };

    const handleColorChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,index:number) => {
        const colour = event.target.value;
        if (colour.length === 0 || !isValidHexColor(colour)) {
          setIsValidColor(false);
        } else {
          setIsValidColor(true);
        }


        const newValues = { ...values };
        newValues.outletActivityTabs.value[index] = { ...newValues.outletActivityTabs.value[index], themeColor: colour }
        setValues({ ...values });
      };

    return (
        <div className="outlet_activity_config_container">
            <ConfigurationHeader heading={"Outlet Activity Configuration"} saveConfiguration={() => saveConfiguration(false)} createPreview={() => saveConfiguration(true)} />
            {!showLoader ? (<div className="config_form_container">
                <div className="form_header">
                    <BorderHeading>Outlet activity Tabs</BorderHeading>
                </div>
                <div className='outlet_activity_config_body_container'>
                    <div className='outlet_activity_config_multiselect_container'>
                        <GenricMultiSelect
                            className="outlet_activity_config_multiselect"
                            options={availableActivityTabOptions}
                            label={"Select outlet activity Options"}
                            selectedOptions={selectedActivityTabOptions}
                            handleMultiSelectState={handleSelectedOutletActivityTabOptions}
                            isRequired={false}
                            params={{ size: "small" }}
                        />
                        <FontAwesomeIcon
                            onClick={handleAddOutletActivityTabOptions}
                            className="outlet_activity_config_plus_icon"
                            icon={faCirclePlus}
                        />
                    </div>
                    <div className={values.outletActivityTabs.value.length===0 ? 'hide_activity_tabs_draggable_contaner':''}>
                    <DragDropContext onDragEnd={handleDragOnEnd}>
                        <Droppable droppableId="droppableOutletActivityTabItems">
                            {(provided) => (
                                <div className="layout_configuration_options_container" {...provided.droppableProps}
                                    ref={provided.innerRef}>
                                    {
                                        values.outletActivityTabs.value.map((activityOption: activityTabOptions, index: number) => {
                                            return (
                                                <Draggable
                                                    key={activityOption.id}
                                                    draggableId={activityOption.id}
                                                    index={index}
                                                // isDragDisabled={activityOption.id==="home"}
                                                >
                                                    {(provided: DraggableProvided) => (
                                                        // <div ref={provided.innerRef} className='must-do-input-card' {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <div className='card' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>

                                                            <div className='activity_tab_item_card' style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <Accordion style={{ width: '100%' }}>
                                                                    <AccordionSummary
                                                                        expandIcon={<ExpandMoreIcon />}
                                                                        aria-controls="panel1a-content"
                                                                        id="panel1a-header"
                                                                    >
                                                                        <div className='activity_option_summary'>
                                                                            <div>
                                                                                <span><FontAwesomeIcon className='transfer_list_grip_lines_icon' icon={faGripLines} /></span>
                                                                                <Typography variant='h6' sx={{ fontWeight: 400, display: 'inline' }}>{activityOption.id}</Typography>
                                                                            </div>
                                                                            <span className='circle_icon activity_circle' onClick={() => handleRemove(activityOption.id)}><span className='hyphen_icon' /></span>
                                                                        </div>
                                                                        {/* <IconButton onClick={()=>{}}><DeleteOutlineOutlinedIcon /></IconButton> */}
                                                                    </AccordionSummary>
                                                                    <AccordionDetails>
                                                                        <div className="activity_tab_card_fields_list">
                                                                            <TextField id="outlined-basic" label="label" variant="outlined" value={activityOption.label} onChange={(e) => handleTextInputChange(e, index, "label")} />

                                                                            <div className='activity_tab_card_field'>
                                                                                <TextField id="outlined-basic" label="storeInRequired" variant="outlined" value={activityOption.storeInRequired} onChange={(e) => handleTextInputChange(e, index, "storeInRequired")} />
                                                                            </div>

                                                                            <TextField
                                                                                id="outlined-start-adornment"
                                                                                size="small"
                                                                                value={activityOption.themeColor}
                                                                                placeholder={"#ffffff"}
                                                                                onChange={(e)=>handleColorChange(e,index)}
                                                                                InputProps={{
                                                                                endAdornment: (
                                                                                    <input
                                                                                    type="color"
                                                                                    id="color-picker"
                                                                                    value={activityOption.themeColor}
                                                                                    onChange={(e)=>handleColorChange(e,index)}
                                                                                    />
                                                                                ),
                                                                                }}
                                                                                error={!isValidColor}
                                                                                helperText={!isValidColor && "Please select a valid hex code"}
                                                                            />



                                                                            <div className="answer_container">
                                                                                <DashboardCheckbox onChange={(e) => handleCheckChange(e, index)} checked={activityOption?.isDefault} name="minOrderValidation" label="is default" />
                                                                            </div>

                                                                        </div>
                                                                    </AccordionDetails>
                                                                </Accordion>
                                                            </div>


                                                        </div>
                                                    )}

                                                </Draggable>
                                            )
                                        })
                                    }
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    </div>
                </div>

            </div>) : <Loader />}
        </div>
    )
}

export default OutletActivityTabsConfiguration